import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useLocation } from 'react-router-dom';
import { TwoFactorVerify } from '@ibk/shared-auth';
import { Card } from '@ibk/shared-ui';
import styles from './TwoFactorVerify.module.css';
import { useTwoFactorVerify } from './useTwoFactorVerify';
export default function TwoFactorVerifyPage() {
    const { state } = useLocation();
    const verifyProps = useTwoFactorVerify(state || {});
    return (_jsx("main", { className: styles.container, children: _jsx(Card, { style: { padding: 36, maxWidth: 340, width: '100%' }, className: styles.card, children: _jsx(TwoFactorVerify, { maskedRecipient: verifyProps.maskedRecipient || '', method: verifyProps.method, disabled: verifyProps.disabled, error: verifyProps.error, onBack: verifyProps.onBack, onContinue: verifyProps.onContinue, onResend: verifyProps.onResend, theme: {
                    primaryColor: '#d64000',
                    linkColor: '#1573D3',
                } }) }) }));
}
